import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const INSTRUCTIONAL_STRATEGIES = 'instructional_strategies'
const LEARNING_STRATEGIES = 'learning_strategies'
const LEARNING_METHODS = 'learning_methods'


/**
 * Form model
 */
const formModel = () => {
  return {
    [INSTRUCTIONAL_STRATEGIES]: {
      label: `Instructional strategies`,
      name: INSTRUCTIONAL_STRATEGIES,
    },
    [LEARNING_STRATEGIES]: {
      label: `Learning strategies`,
      name: LEARNING_STRATEGIES,
    },
    [LEARNING_METHODS]: {
      label: `Learning methods`,
      name: LEARNING_METHODS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [INSTRUCTIONAL_STRATEGIES]: '',
  [LEARNING_STRATEGIES]: '',
  [LEARNING_METHODS]: '',
}


export default formModel
